import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeProvider';
import Home from './pages/Home';
import SwitchWrapper from './utils/theme/SwitchWrapper';

import styled from 'styled-components';

const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			<Route path="/" element={<Home />} />
		</>
	)
);

function App() {
	return (
		<>
			<Container>
				<ThemeProvider>
					<SwitchWrapper>
						<RouterProvider router={router} />
					</SwitchWrapper>
				</ThemeProvider>
			</Container>
		</>
	);
}
const Container = styled.div``;
export default App;
